import React, { useState } from "react";
import styles from './index.module.css';
import { useMotionValueEvent, useScroll } from "framer-motion";
import { Sparkels } from "../../Components";
import { Threat1, Threat2 } from "../../assets";

const ThreatAnalysis = (props) => {
    const [scrollPos, setScrollPos] = useState(0);
    const { scrollY } = useScroll();

    useMotionValueEvent(scrollY, "change", (latest) => {
        latest < 400 && setScrollPos(latest);
    });
    
    return (
        <div className="bg-[#020714]">
            <div className={`${styles["hero-spacer"]}`} />
            <div
                key={scrollPos}
                style={{ bottom: 0 }}
                className={`${styles["content-section"]}`}
            >
                <p className={`${styles.subt}`}>
                    Advanced Chess Intelligence
                </p>
                <h3 className={`${styles.title}`}>
                    Real-Time Threat Analysis
                    <br />
                    Engine-Assisted Precision
                </h3>
                <Sparkels />
                <p className={`${styles.subp}`}>
                    Gain a competitive edge with our highly accurate, real-time threat analysis powered by advanced chess engines. 
                    Instantly identify tactical opportunities and avoid potential pitfalls in your games.
                </p>
                
                <div className={`${styles.cardContainer}`}>
                    <div className={`${styles.card}`}>
                        <div className={`${styles.cardHeader}`}>
                            <svg className={`${styles.cardIcon}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor">
                                <rect x="6" y="6" width="12" height="12" rx="2" ry="2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                                <path d="M12 6v12M6 12h12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M8 6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8z" fill="currentColor" fillOpacity="0.3" />
                                <path d="M14 12a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2z" fill="currentColor" fillOpacity="0.3" />
                            </svg>
                            <h4 className={`${styles.cardTitle}`}>Accurate Threat Detection</h4>
                        </div>
                        <p className={`${styles.cardDescription}`}>
                            Our threat analysis is powered by the best chess engines, providing you with accurate insights in real-time. 
                            Identify threats and develop stronger strategic awareness.
                            <br/>
                            <br/>
                        </p>
                        <div className={`${styles.imageContainer}`}>
                            {/* Placeholder for image 1 */}
                            <div className={`${styles.imagePlaceholder}`}>
                                <img src={Threat1} />
                            </div>
                        </div>
                    </div>
                    
                    <div className={`${styles.card}`}>
                        <div className={`${styles.cardHeader}`}>
                            <svg className={`${styles.cardIcon}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                            <h4 className={`${styles.cardTitle}`}>Real-Time Tactical Insights</h4>
                        </div>
                        <p className={`${styles.cardDescription}`}>
                            Never miss a critical threat again. Our system continuously analyzes the board position, highlighting potential dangers and opportunities as they emerge. 
                            Enhance your learning experience with instant feedback on every move.
                        </p>
                        <div className={`${styles.imageContainer}`}>
                            {/* Placeholder for image 2 */}
                            <div className={`${styles.imagePlaceholder}`}>
                            <img src={Threat2} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThreatAnalysis;
